import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { makeAnonymousMutator, Options } from '../../../core/requests/anonymous-mutator';
import { Language } from '../../../core/i18n/constants';

export type MutationOptions<TData = unknown, TPayload = unknown> = {
  options?: Omit<UseMutationOptions<TData, unknown, TPayload, unknown>, 'mutationFn'>;
  url: string;
  method: Options['method'];
  bodyType?: Options['bodyType'];
  language: Language;
};

export function useAnonymousMutation<TData, TPayload>({
  url,
  options,
  method,
  bodyType,
  language,
}: MutationOptions<TData, TPayload>) {
  const mutationFn = makeAnonymousMutator<TData, TPayload>({
    url: url,
    method: method,
    bodyType: bodyType,
    language,
  });

  return useMutation({ ...options, retry: false, mutationFn });
}
